@let isMobile = isMobile$ | async;
<div class="modal">
  <button class="close-round" [mat-dialog-close]="false">
    <span class="close-round__btn"></span>
  </button>

  <h3 class="title"
      [innerHTML]="'trade-popup.title.main' | translate: {
        serverName: 'open-account.label.' + account.server.type.toLowerCase() | translate }">
  </h3>

  <div class="modal__content">
    <div class="account">
      <div class="account__item">
        <span class="account__item-name" translate="account.label.login"></span>
        <div class="account__item-info">
        <span
            class="account__item-value account__item-value--login"
            [innerHTML]="account.login"
        ></span>
          <tooltip-copy-link
              type="icon"
              [copiedTooltipLabel]="'register-account-certificate.tooltip.copied' | translate"
              [copyLabel]="'register-account-certificate.label.copy' | translate"
              [text]="account.login.toString()"
              (copied)="onCopy('login')"
          />
        </div>
      </div>

      <div class="account__item">
        <span class="account__item-name" translate="account.label.password"></span>
        <global-account-viewer-password
            class="password"
            [account]="account"
        />
      </div>
      <div class="account__item">
        <span class="account__item-name" translate="account.label.server"></span>
        <div class="account__item-info">
        <span class="account__item-value account__item-value--settings"
              [innerHTML]="account.server.name"
        ></span>
          <tooltip-copy-link
              type="icon"
              [copiedTooltipLabel]="'register-account-certificate.tooltip.copied' | translate"
              [copyLabel]="'register-account-certificate.label.copy' | translate"
              [text]="account.server.name"
              (copied)="onCopy('server')"
          />
        </div>
      </div>

      <div class="account__item">
        <span class="account__item-name" translate="account.label.server-ip"></span>
        <div class="account__item-info">
        <span class="account__item-value"
              [innerHTML]="account.server.address"
        ></span>
          <tooltip-copy-link
              type="icon"
              [copiedTooltipLabel]="'register-account-certificate.tooltip.copied' | translate"
              [copyLabel]="'register-account-certificate.label.copy' | translate"
              [text]="account.server.address"
          />
        </div>
      </div>
    </div>

    @if (!isMobile) {
      <div class="qr-code">
        <qrcode
            class="qr-code__holder"
            [errorCorrectionLevel]="'M'"
            [margin]="2"
            [qrdata]="metaTraderQRUrl"
            [width]="90"
        />

        <div class="qr-code__info">
          <h3 class="title title--sub">
            {{ "trade-popup.title.qr" | translate }}
            <svg-icon-sprite
                class="qr-code__hint"
                matTooltipPosition="above"
                matTooltipShowDelay="100"
                [matTooltip]="'trade-popup.hint.qr' | translate: { serverName: 'open-account.label.' + server.toLowerCase() | translate}"
                [src]="'./assets/img/icons/sprite.svg#hint'"
            />
          </h3>
          <p
              class="qr-code__text"
              [innerHTML]="'trade-popup.text.qr' | translate: { serverName: 'open-account.label.' + server.toLowerCase() | translate }"
          ></p>
        </div>
      </div>
    }

    <div class="download">
      <div class="download__app-block">
        @if (isMobile) {
          <btn
              iconHeight="24px"
              iconName="mobile"
              iconWidth="24px"
              routerLink="/redirect/metatrader"
              [buttonText]="'trade-popup.download.mobile' | translate"
              [mat-dialog-close]="false"
              [queryParams]="{
                login: account.login,
                server: account.server.name,
                version: server,
              }"
              [selection]="true"
              [wide]="true"
          />
        }

        @if (!isMobile) {
          <btn
              iconHeight="24px"
              iconName="globe"
              iconWidth="24px"
              [buttonText]="'trade-popup.download.terminal' | translate"
              [gaEventOptions]="{
                          context: 'account_details',
                          object: 'GoToWebTerminal',
                          button_id: 'trade-popup.download.terminal'
                        }"
              [mat-dialog-close]="false"
              [pagGaEventClick]="eventType.InteractiveClick"
              [selection]="true"
              [wide]="true"
              (action)="controlAppButtons('web-app')"
          />

          <btn
              iconHeight="24px"
              iconName="desktop"
              iconWidth="24px"
              [buttonText]="'trade-popup.download.desktop' | translate"
              [gaEventOptions]="{
                          context: 'account_details',
                          object: 'GetDesktopApp',
                          button_id: 'trade-popup.download.desktop'
                        }"
              [mat-dialog-close]="false"
              [pagGaEventClick]="eventType.InteractiveClick"
              [selection]="true"
              [wide]="true"
              (action)="controlAppButtons('desktop-app')"
          />
        }
      </div>
    </div>
  </div>
</div>
